import { get, post, remove } from './api';
import routes from './end-points';
export const bankAccountsApi = {
  initMyAccounts: () => get(routes.bankAccounts.initMyAccounts),
  saveChanges: (dto) => post(routes.bankAccounts.saveChanges, dto),
  delete: (id) => remove(routes.bankAccounts.delete(id)),
  initByAdmin: (userName) => get(`${routes.bankAccounts.initByAdmin}?userName=${userName}`),
};
